<template>
  <div id="app">
    <div class="update-tips">
<!--      <div v-if="showDeadlineTips">-->
<!--        您的微聊客服即将到期，截止日期2019-01-01，请尽快续费或升级。续费客服电话：13777577170，QQ：80068726-->
<!--        <i class="el-icon-close tips-close" @click="closeDeadlineTips"></i>-->
<!--      </div>-->
      <div v-if="showUpdateTips && updateInfo.upgradeTips == '2'">
          <div v-html="updateInfo.content"></div>
<!--        尊敬的用户，您好！系统定于{{updateInfo.time}}凌晨00：00至{{updateInfo.time}}凌晨4：00进行升级，升级期间将无法访问（包括商户后台、用户前台、PC客户端及APP），由此给您带来的不便，敬请谅解！-->
        <i class="el-icon-close tips-close" @click="closeUpdateTips"></i>
      </div>

    </div>
    <div class="app-view">
      <router-view/>
    </div>


  </div>
</template>

<script>
  export default {
    name: 'App',
    data(){
      return {
        showUpdateTips: true,
        showDeadlineTips: false,
        routeWhite:['login','register','forget'],
      }
    },
    computed:{
      currentRouter(){
        this.checkRoute(this.$route.name)
      },
      updateInfo(){
        return this.$store.state.user.updateInfo
      },
    },
    watch:{
      $route: {
        handler: function(val, oldVal){
          this.checkRoute(val.name)
        },
        // 深度观察监听
        deep: true
      }
    },
    created(){
      this.currentRouter
    },
    mounted(){
    },
    methods:{
      closeUpdateTips(){
        this.showUpdateTips = false
      },
      closeDeadlineTips(){
        this.showDeadlineTips = false
      },
      checkRoute(str){
        let r = this.routeWhite.indexOf(str)
        if(r > -1){
          this.showTips = false
        }else {
          this.showTips = true
        }
      },
    }
  }
</script>

<style lang="scss">
#app{
  display: flex;
  flex-direction: column;
  .update-tips > div{
    line-height: 24px;
      padding: 8px 0;
    text-align: center;
    background-color: #f2dede;
    color: #a94442;
    font-size: 14px;
    font-weight: bold;
    position: relative;
      box-sizing: border-box;
    .tips-close{
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      font-weight: bold;
      cursor: pointer;
    }
  }
  .update-tips > div +div{
    border-top: 1px solid #ccc;
  }
  .app-view{
    flex: 1;
    height: 100%;
    overflow-y: scroll;
  }
}
</style>
